import { useMutation } from 'react-query';

import { setProgressPreferences as mutationFn } from 'api/endPoints/setProgressPreferences';

import { TBaselineComparable } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProjectPreferences/ProjectPreferences.utils';

export const useMutationSetProgressPreferences = () => {
    return useMutation<
        unknown,
        QueryError,
        {
            projectId: number;
            selectedOption: TBaselineComparable;
        }
    >((params: { projectId: number; selectedOption: TBaselineComparable }) => mutationFn(params));
};
